/* eslint-disable quotes */

const outbound_settings = {
  tabs: {
    sender_ip: '送信者 IP アドレス範囲',
    tagline: 'キャッチフレーズ/フッター',
    encryption: 'DLP/暗号化',
    content_policies: 'コンテンツポリシー',
    notifications: '通知'
  },
  save: '変更を保存',
  cancel: '[キャンセル]',
  bulk_edit: '一括編集',
  sender_ip: {
    title: '送信者 IP アドレス範囲',
    subtitle: 'ドメインからの送信メールの送信を許可する IP アドレス範囲を指定します。',
    domain_column: 'ロギングとポリシードメイン',
    ip_column: 'IP アドレス',
    netmask: 'ネットマスク',
    comment: '[コメント]',
    actions: '[アクション]',
    add: '追加',
    remove: '[削除]',
    bulk_edit: '一括編集',
    confirm_removal: '削除を確認しますか?',
    empty_domain: 'ドメイン名を指定してください',
    invalid_ip_address: '有効な IP アドレスを入力してください',
    outbound_relay: {
      title: '共有IPによるアウトバウンドリレーを有効にする',
      tooltip:
        'この設定を新たに有効にし、Microsoft 365 や Google Workspace 以外のカスタム IP 範囲を使用するお客様は、引き続きサポートに連絡し、それらの IP アドレスを当社のシステムに追加してもらうか、ご利用のメールサービスプロバイダーがサポート対象であるかを確認する必要があります。',
      toggle_label: '共有IPによるアウトバウンドリレーを有効にする',
      helper_text: '送信メールを、自動的に追跡される共有IP経由で送信する。'
    }
  },
  tagline: {
    title: 'キャッチフレーズ/フッター',
    append_label: 'タグラインを追加',
    append_description: '送信メールに次のテキストを追加します',
    tagline_label: 'キャッチフレーズ/フッターテキスト',
    characters_left: '残りの文字数:{残り文字数}'
  },
  encryption: {
    title: 'DLP/暗号化',
    all_messages: 'すべての送信メッセージに TLS 接続が必要',
    selected_domains: '特定の受信者ドメインに TLS 接続を要求',
    table_description_all:
      'Email Gateway Defense に、<b>特定の受信者ドメインを除くすべてのドメインへの安全な</b> TLS 接続を要求するように強制するには、除外する受信者ドメイン名を入力して [追加] をクリックしてください。',
    table_description_select:
      'Email Gateway Defense が受信者ドメインへの安全な TLS 接続を要求するように強制するには、受信者のドメイン名を入力して [追加] をクリックします。',
    table_sub_description: 'TLS 接続を確立できない場合、メールは受信者ドメインに送信されません。',
    save_changes_helper: '一括編集を有効にするには、変更を保存してください'
  },
  content_policies: {
    title: 'コンテンツポリシー',
    attachment_filter: '添付ファイルフィルター',
    filter_type: 'フィルタータイプ',
    pattern: 'パターン',
    check_archives: 'アーカイブをチェック',
    action: 'アクション',
    comment: '[コメント]',
    actions: '[アクション]',
    add: '追加',
    remove: '[削除]',
    no: 'いいえ',
    yes: 'はい',
    scan: 'スキャン',
    do_not_scan: 'スキャンしない',
    block: '[ブロック]',
    ignore: '無視',
    allow: '許可',
    quarantine: '検疫',
    encrypt: '[暗号化]',
    not_encrypt: '暗号化しないでください',
    filename: '[ファイル名]',
    mime: 'マイムタイプ',
    message_content_filter: 'メッセージコンテンツフィルター',
    subject: '件名',
    headers: 'ヘッダー',
    body: 'ボディ',
    attachments: '添付ファイル',
    sender: '送信者',
    recipient: '受信者',
    match: 'マッチ',
    one_match_filter: '少なくとも 1 つのマッチフィルターを選択する必要があります。',
    duplicate_value: '重複したエントリが存在します。',
    empty_pattern: 'パターンを指定してください。',
    archive_filtering: 'パスワードで保護されたアーカイブフィルタ:',
    msoffice_filtering: 'パスワードで保護されたマイクロソフトオフィス文書:',
    pdf_filtering: 'パスワードで保護された PDF フィルタリング:',
    predefined_filters: '定義済みフィルター',
    predefined_filters_description:
      '件名、本文、添付ファイルで、送信メッセージをフィルタリングして、事前に定義された（米国特有の）データ漏洩パターンを見つけます。推奨処置:暗号化',
    creditcard: 'クレジットカード',
    ssn: '社会保障番号',
    privacy: 'プライバシー',
    hipaa: 'ヒパー',
    predefined_filter_exceptions: '定義済みフィルター例外',
    predefined_filter_exceptions_description:
      '定義済みの HIPAA またはプライバシーコンテンツフィルターに免除を追加します。',
    type: 'タイプ',
    phone_number: '電話番号',
    address: '住所',
    missing_filtering_pattern: 'フィルタリングパターンが見つかりません。',
    error_invalid_phone_number: '電話番号が無効です',
    invalid_regex_warning: 'パターンに無効な正規表現構文が含まれています',
    save: '[保存]'
  },
  notifications: {
    title: '通知',
    admin_quarantine_notification: '管理者隔離通知',
    admin_quarantine_notification_description:
      'アウトバウンド検疫情報をまとめた通知レポートを管理者が受け取る頻度を設定します。',
    notification_interval: '通知間隔',
    never: '決して',
    immediately: '直ちに',
    scheduled: 'スケジュール済み',
    schedule_notification_intervals: '通知間隔をスケジュールする',
    matrix_description:
      '通知は、選択した時間ブロック内の任意の時点で送信されます。<br></br>クリックしてドラッグして選択します。Ctrl キーを押したままドラッグすると、選択が解除されます。',
    notification_address: '通知アドレス',
    sender_quarantine_notification: '送信者隔離通知',
    sender_quarantine_notification_description:
      '配信不能レポート (NDR) を有効にすると、何らかの理由で隔離された送信メッセージの送信者に送信されるように設定します。この NDR は、メッセージが管理者による評価と処理を待っていることを示しています。',
    quarantine_sender_notification: '検疫送信者通知',
    yes: 'はい',
    no: 'いいえ',
    quarantine_notification_address: '隔離通知アドレス',
    quarantine_notification_subject: '隔離通知件名',
    quarantine_notification_subject_placeholder: '**送信したメッセージはポリシーに違反しています**',
    quarantine_notification_template: '検疫通知テンプレート',
    quarantine_notification_template_placeholder:
      '%R へのメッセージは、バラクーダネットワークスのメールゲートウェイディフェンスによって隔離されました。次の件名で送信されたメールは配信されておらず、アカウント管理者またはドメイン管理者による評価待ちです。\n\n件名:%j',
    notification_to_sender: '拒否されたメッセージの送信者への通知',
    notification_to_sender_description:
      '隔離された送信メッセージが管理者によって拒否された場合に送信者に電子メールで送信される配信不能レポート (NDR) を設定します。',
    reject_notification_address: '拒否通知アドレス',
    reject_notification_subject: '拒否通知件名',
    reject_notification_subject_placeholder: '**送信したメッセージはポリシーに違反しています**',
    reject_notification_template: '拒否通知テンプレート',
    reject_notification_template_placeholder:
      '%R へのメッセージはドメイン管理者によって拒否されたため、配信されません。メール管理者に問い合わせてください。\n\n件名:%j',
    admin_spam_notification: '管理者向け迷惑メール通知',
    admin_spam_notification_description:
      'ユーザーがアウトバウンドスパムを送信した疑いがある場合に通知を受け取るメールアドレスを設定します。',
    spam_notification_address: '迷惑メール通知アドレス',
    invalid_email: '{email} は有効なメールアドレスではありません。カンマの後にスペースが入らないようにしてください。',
    email_belong_to_manage_domain: 'メールアドレスは、管理するドメインに属している必要があります。',
    blank_email: 'Eメールアドレスを入力してください'
  }
}

/* eslint-enable quotes */

export default outbound_settings
